module.exports = __webpack_public_path__ + "static/media/padlock-dark.34da51cf.svg";